/**
 * Shared vocabulary for everything the panel says about a subscription, so the
 * clients list, the subscribers tab and the detail dialog cannot drift apart
 * on what "past_due" is called.
 */

export type SubscriptionStatus =
  | "incomplete"
  | "trialing"
  | "active"
  | "past_due"
  | "paused"
  | "cancelled"
  | "expired";

export const SUBSCRIPTION_STATUS: Record<
  SubscriptionStatus,
  { label: string; variant: "default" | "secondary" | "destructive" | "outline" }
> = {
  incomplete: { label: "W toku", variant: "outline" },
  trialing: { label: "Okres próbny", variant: "default" },
  active: { label: "Aktywna", variant: "default" },
  past_due: { label: "Zaległa", variant: "destructive" },
  paused: { label: "Wstrzymana", variant: "secondary" },
  cancelled: { label: "Anulowana", variant: "secondary" },
  expired: { label: "Wygasła", variant: "secondary" },
};

/** Statuses the filter bar offers. `trialing` exists in the database but no
 *  plan can be configured with a trial, so it is not offered here. */
export const ALL_SUBSCRIPTION_STATUSES: SubscriptionStatus[] = [
  "active",
  "past_due",
  "paused",
  "cancelled",
  "expired",
  "incomplete",
];

export const INTERVAL_SHORT: Record<string, string> = {
  month: "/ mies.",
  quarter: "/ kwartał",
  year: "/ rok",
  once: "jednorazowo",
};

export const zl = (grosze: number) =>
  `${(grosze / 100).toFixed(2).replace(".", ",")} zł`;

export function formatDate(d: Date | string) {
  return new Date(d).toLocaleDateString("pl-PL", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function formatDateTime(d: Date | string) {
  return new Date(d).toLocaleDateString("pl-PL", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function clientLabel(client: {
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  deleted: boolean;
}) {
  if (client.deleted) return "Konto usunięte";
  return (
    [client.firstName, client.lastName].filter(Boolean).join(" ") ||
    client.email ||
    "—"
  );
}

/** Days from now, negative when already past. */
export function daysUntil(d: Date | string) {
  return Math.ceil((new Date(d).getTime() - Date.now()) / 86_400_000);
}
